export default __webpack_public_path__ + "static/media/twitter.aab5110f.png";